export default {
    ERROR_CODES: {
        FORCE_LOGOUT: '99999',
        APP_DISABLED: '99998',
    },
};
